<section class="driver" *ngIf="driverData">
  <h5 class="driver--title">
    {{ 'driverData' | i18next }}
  </h5>
  <div class="driver--driverData">
    <div class="driver--driverData__row">
      <p class="label">{{ 'loanDriver' | i18next }}</p>
      <p class="text">
        {{
          driverData.type
            ? this.translate.translateDriverType(driverData.type)
            : '-'
        }}
      </p>
    </div>
    <div class="driver--driverData__row">
      <p class="label">{{ 'drivingLicense' | i18next }}</p>
      <p class="text">
        {{ driverData.drivingLicense ? 'Si' : 'No' }}
      </p>
    </div>
    <div
      class="driver--driverData__row"
      *ngIf="driverData.type === 'INTERNAL' && !isModify"
    >
      <p class="label">{{ 'nis' | i18next }}</p>
      <p class="text">
        {{ driverData.userId ? driverData.userId : '-' }}
      </p>
    </div>
    <div
      class="driver--driverData__row"
      *ngIf="driverData.type === 'INTERNAL' && !isModify"
    >
      <p class="label">{{ 'fullname' | i18next }}</p>
      <p class="text">
        {{ driverData.fullName ? driverData.fullName : '-' }}
      </p>
    </div>
    <div
      class="driver--driverData__row"
      *ngIf="driverData.type === 'EXTERNAL' && !isModify"
    >
      <p class="label">
        {{ 'dni' | i18next }}
      </p>
      <p class="text">
        {{
          driverData.externalData
            ? driverData.externalData.identificationDocument
              ? driverData.externalData.identificationDocument
              : '-'
            : '-'
        }}
      </p>
    </div>
  </div>
  <div class="driver--driverData" *ngIf="driverData.type === 'EXTERNAL'">
    <div class="driver--driverData__row" *ngIf="!isModify">
      <p class="label">
        {{ 'fullname' | i18next }}
      </p>
      <p class="text">
        {{
          driverData.externalData
            ? driverData.externalData.fullName
              ? driverData.externalData.fullName
              : '-'
            : '-'
        }}
      </p>
    </div>
    <div class="driver--driverData__row">
      <p class="label">
        {{ 'city' | i18next }}
      </p>
      <p class="text">
        {{
          driverData.externalData
            ? driverData.externalData.city
              ? driverData.externalData.city
              : '-'
            : '-'
        }}
      </p>
    </div>
    <div class="driver--driverData__row">
      <p class="label">{{ 'address' | i18next }}</p>
      <p class="text">
        {{
          driverData.externalData
            ? driverData.externalData.address
              ? driverData.externalData.address
              : '-'
            : '-'
        }}
      </p>
    </div>
    <div class="driver--driverData__row">
      <p class="label">{{ 'postalCode' | i18next }}</p>
      <p class="text">
        {{
          driverData.externalData
            ? driverData.externalData.zipCode
              ? driverData.externalData.zipCode
              : '-'
            : '-'
        }}
      </p>
    </div>
    <div class="driver--driverData__row">
      <p class="label">
        {{ 'optionals' | i18next }}
      </p>
      <p class="text">
        {{
          driverData.externalData
            ? driverData.externalData.phoneNumber
              ? driverData.externalData.phoneNumber
              : '-'
            : '-'
        }}
      </p>
    </div>
    <div class="driver--driverData__row">
      <p class="label">
        {{ 'email' | i18next }}
      </p>
      <p class="text">
        {{
          driverData.externalData
            ? driverData.externalData.email
              ? driverData.externalData.email
              : '-'
            : '-'
        }}
      </p>
    </div>
  </div>
  <form [formGroup]="driverForm">
    <div
      *ngIf="driverData.type === 'EXTERNAL' && isModify"
      class="driver--driverData"
    >
      <div class="driver--driverData__row">
        <mat-form-field class="width-standar">
          <mat-label>{{ 'fullnameResume' | i18next }}</mat-label>
          <input
            matInput
            type="text"
            class="loan-request--select__input"
            formControlName="fullName"
          />
        </mat-form-field>
      </div>
    </div>
    <div
      *ngIf="driverData.type === 'INTERNAL' && isModify"
      class="driver--driverData"
    >
      <div class="driver--driverData__row">
        <mat-form-field class="width-standar">
          <mat-label>{{ 'introduceNis' | i18next }}</mat-label>
          <input
            matInput
            type="text"
            class="loan-request--select__input"
            formControlName="nis"
            (change)="updateInfoNis()"
          />
        </mat-form-field>
      </div>
      <div class="driver--driverData__row">
        <mat-form-field class="custom-autocomplete">
          <mat-label>{{ 'fullnameResume' | i18next }}</mat-label>
          <input
            class="loan-request--select__input"
            type="text"
            matInput
            [formControl]="searchControl"
            formControlName="fullName"
            [matAutocomplete]="auto"
            (change)="updateInfoNis()"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="onOptionSelected($event)"
          >
            <mat-option
              *ngFor="let option of filteredOptions | async"
              [value]="option"
            >
              {{ option.fullName }} {{ option.id }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="nisErrorContainer">
        <small class="error-message" *ngIf="nisError">{{
          'errorWrongNis' | i18next
        }}</small>
        <small class="error-message" *ngIf="nisErrorLength">{{
          'nisErrorLength' | i18next
        }}</small>
        <small class="error-message" *ngIf="errorNisName">{{
          'errorNoNisAndNoName' | i18next
        }}</small>
        <small class="error-message" *ngIf="nameError">{{
          'nameError' | i18next
        }}</small>
        <small class="error-message" *ngIf="noNameError">{{
          'noNameError' | i18next
        }}</small>
      </div>
    </div>
  </form>
  <button
    *ngIf="isModify"
    class="modify--btn"
    (click)="sendLoanModify()"
    [disabled]="driverForm.invalid"
    [ngStyle]="
      driverForm.invalid
        ? { 'background-color': '#efffc1', 'font-weight': 'normal' }
        : { 'background-color': '#c8f546' }
    "
  >
    {{ 'btnSave' | i18next | uppercase }}
  </button>
</section>
